import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class StampAPI extends ComponentAPI {
    getColor() {
        return this.state.color;
    }
    setColor(color) {
        this.setState({ color });
    }
    isEnableAutoHide() {
        return Boolean(this.state.enableAutoHide);
    }
    setEnableAutoHide(enableAutoHide) {
        this.setState({ enableAutoHide });
    }
    getIcon() {
        return this.state.icon;
    }
    setIcon(icon) {
        this.setState({ icon });
    }
    getLabel() {
        return this.state.label;
    }
    setLabel(label) {
        this.setState({ label });
    }
}
export default StampAPI;
//# sourceMappingURL=stamp-api.js.map